<template>
  <!-- 申请明细中creditInfo的展示 -->
  <div>
    <card-view
      :source-data="creditInfoData"
      :schema="schema"
      class="creditInfoData"
    >
      <template v-slot:riskEvaluation="slotProps">
        <span>
          {{ slotProps.item.value }}
          <a-button v-if="hasRiskModal" type="link" @click="handleRiskClick">
            {{ slotProps.item.value ? '已评估' : '待评估' }}
          </a-button>
        </span>
      </template>
      <!--业务模式-->
      <template v-slot:model="slotProps">
        <div v-if="sn" class="hasSn">
          <a-select
            v-decorator="
              $decorator('modelId', '请选择业务模式', [{ required: true }])
            "
            placeholder="请选择"
            ref="modelId"
            style="width:200px"
            :defaultValue="creditInfo.model"
            @change="handleChangeModel"
            @focus="handleModelFocus"
          >
            <a-select-option
              v-for="item in modelList"
              :value="item.id"
              :key="item.id"
              :disabled="item.disabled"
            >
              {{ item.name }}
            </a-select-option>
          </a-select>
        </div>
        <div v-else>
          {{ slotProps.item.value }}
        </div>
      </template>

      <template v-slot:segmentId="slotProps">
        <!-- Segment -->
        <div v-if="sn" class="hasSn">
          <a-select
            v-decorator="
              $decorator('segmentId', '请选择Segment', [{ required: true }])
            "
            placeholder="请选择"
            ref="segmentId"
            style="width:200px"
            :defaultValue="creditInfo.segmentId"
            @change="handleSegmentChange"
            @focus="handleSegmentFocus"
          >
            <a-select-option value="0" key="0">all</a-select-option>
            <a-select-option
              v-for="optionItem in segmentOptionList"
              :value="optionItem.id"
              :key="optionItem.id"
              :disabled="optionItem.disabled"
            >
              {{ optionItem.segmentLevel }}
            </a-select-option>
          </a-select>
        </div>
        <div v-else>
          {{ slotProps.item.value }}
        </div>
      </template>

      <template v-slot:link="slotProps">
        <!-- 链路 -->
        <div v-if="sn" class="hasSn">
          <a-select
            v-decorator="$decorator('link', '请选择链路', [{ required: true }])"
            placeholder="请选择"
            ref="link"
            style="width:200px"
            :defaultValue="creditInfo.link"
            @change="handleChangeLink"
          >
            <a-select-option
              v-for="optionItem in linkOptionList"
              :value="optionItem.id"
              :key="optionItem.id"
            >
              {{ optionItem.name }}
            </a-select-option>
          </a-select>
        </div>
        <div v-else>
          {{ slotProps.item.value }}
        </div>
      </template>

      <!-- 审批类型 -->
      <template v-slot:riskType="slotProps">
        <div v-if="canEditRiskType">
          <a-select
            placeholder="请选择审批类型"
            style="width:200px"
            :defaultValue="creditInfoData.riskType"
            @change="handleRiskTypeChange"
          >
            <a-select-option :value="1">一般审批</a-select-option>
            <a-select-option :value="2">高风险审批</a-select-option>
          </a-select>
        </div>
        <div v-else>
          {{ slotProps.item.value }}
        </div>
      </template>
    </card-view>

    <a-modal
      title="信用风险等级评估"
      :visible="showRiskModal"
      :confirm-loading="confirmLoading"
      :mask-closable="false"
      @ok="handleCalc"
      @cancel="closeModal"
      cancel-text="关闭"
      ok-text="计算得分"
    >
      <credit-risk-rating ref="creditRiskRating" />
    </a-modal>

    <a-modal
      title="信用风险等级计算结果"
      :visible="showRiskResultModal"
      :mask-closable="false"
      @ok="comfirmResult"
      @cancel="closeResultModal"
      cancel-text="返回重测"
      ok-text="确认结果"
    >
      <p>信用风险等级：{{ creditInfoData.riskEvaluation }}</p>
    </a-modal>
  </div>
</template>

<script>
import { CardView } from 'lxfintech-fe'
import { APPLY_VIEW_SCHEMA } from '../../schema'
import { CREDIT_TYPE_VALUE_OBJ } from '../../const'
import cloneDeep from 'lodash/cloneDeep'
import CreditRiskRating from './CreditRiskRating/index.vue'
import {
  getModelList,
  getSegmentLevelList,
  getFreezeModelList,
  getFreezeSegmentList,
} from '@/views/credit-approval/apply/api'

export default {
  name: 'CreditInfoView',
  data() {
    return {
      creditInfoData: {},
      schema: null,
      showRiskModal: false,
      showRiskResultModal: false,
      confirmLoading: false,
      riskEvaluationId: '',
      showRisk: false,
      sn: '',
      modelList: [],
      segmentOptionList: [], //segment列表
      linkOptionList: [], //链路列表
      moList: [], //业务模式冻结
      segmentList: [], //segment冻结
    }
  },
  created() {
    const { sn } = this.$route.query
    this.sn = sn
  },
  props: [
    'type',
    'riskEvaluation',
    'creditInfo',
    'hasRiskModal',
    'canEditRiskType',
  ],
  watch: {
    creditInfo: {
      handler(newVal) {
        if (newVal) {
          this.creditInfoData = cloneDeep(newVal)
          // 确保包含 riskType 字段，如果没有数据就设为空字符串
          this.$set(this.creditInfoData, 'riskType', newVal.riskType || '')
        }
      },
      immediate: true,
      deep: true,
    },
    canEditRiskType: {
      handler() {
        // 当权限状态变化时，重新初始化schema
        this.initSchemaByType()
      },
    },
  },
  mounted() {
    this.initSchemaByType()
    //业务模式——下拉框
    if (this.sn) {
      this.changeBusiness(this.creditInfoData.businessId)
    }
    //Segment
    this.getSegmentLevelLists(this.creditInfoData.businessId)
    //链路
    this.getLinkOptionList()
    this._getFreezeSegmentList()
    // 确保 creditInfoData 包含 riskType 字段，没有数据就设为空字符串
    this.$set(
      this.creditInfoData,
      'riskType',
      (this.creditInfo && this.creditInfo.riskType) || '',
    )
  },
  methods: {
    //业务模式禁用
    handleModelFocus() {
      if (this.modelList) {
        this.modelList.forEach(item => {
          item.disabled = false //每次下拉都需要重置禁用属性
        })
      }
      if (this.moList) {
        this.modelList.forEach(item => {
          this.moList.forEach(myitem => {
            if (item.id === myitem.id) {
              item.disabled = true
            }
          })
        })
        this.$forceUpdate() //刷新组件
      }
    },
    //Segment禁用
    handleSegmentFocus() {
      if (this.segmentOptionList) {
        this.segmentOptionList.forEach(item => {
          item.disabled = false //每次下拉都需要重置禁用属性
        })
      }
      if (this.segmentList) {
        this.segmentOptionList.forEach(item => {
          this.segmentList.forEach(myitem => {
            if (item.id === myitem.id) {
              item.disabled = true
            }
          })
        })
        this.$forceUpdate() //刷新组件
      }
    },

    // 根据type修改schema
    initSchemaByType() {
      const type = this.type
      let schema = cloneDeep(APPLY_VIEW_SCHEMA)
      if (type == CREDIT_TYPE_VALUE_OBJ.CREDIT_TYPE) {
        // 当为信用限额时，无信控区
        delete schema.creditArea
      }
      // 只有 type 为 1/5/6/7 时才显示审批类型
      if (![1, 5, 6, 7].includes(parseInt(type))) {
        delete schema.riskType
      } else if (this.canEditRiskType) {
        // 如果有编辑权限，使用插槽显示下拉框
        schema.riskType = {
          label: '审批类型',
          slotName: 'riskType',
        }
      }
      this.schema = schema
      this.showRisk = this.onRiskShow()
    },

    //1. 正常/临时/专项额度
    //2. 业务类型选择了 “PCSD”或“DCG”
    //3. 同时业务模式选择了“渠道客户”
    //4. 满足以上3个条件才需要评估风险
    onRiskShow() {
      let types = [
        CREDIT_TYPE_VALUE_OBJ.NORMAL_TYPE,
        CREDIT_TYPE_VALUE_OBJ.TEMPORARY_TYPE,
        CREDIT_TYPE_VALUE_OBJ.SPECIAL_TYPE,
      ]
      let type = Number(this.type)
      let businessArr = ['PCSD', 'DCG']
      if (
        types.includes(type) &&
        businessArr.includes(this.creditInfo.business) &&
        this.creditInfo.model === '渠道客户'
      ) {
        this.$set(this.schema, 'riskEvaluation', {
          label: '信用风险等级评估',
          slotName: 'riskEvaluation',
        })
        this.$set(this.creditInfoData, 'riskEvaluation', this.riskEvaluation)
        return true
      }
      return false
    },
    handleRiskClick() {
      this.showRiskModal = true
      this.$nextTick(async () => {
        const { companyCode } = this.$route.query
        const riskData = await this.$refs.creditRiskRating.getRiskData({
          companyCode,
          riskEvaluationId: this.riskEvaluationId,
        })
        riskData && (this.riskEvaluationId = riskData.id)
      })
    },
    closeModal() {
      this.showRiskModal = false
    },

    // 计算得分
    async handleCalc() {
      let data = await this.$refs.creditRiskRating._calcEvaluate()
      if (data) {
        ;({
          result: this.creditInfoData.riskEvaluation,
          id: this.riskEvaluationId,
        } = data)
        this.showRiskResultModal = true
      }
    },
    comfirmResult() {
      this.closeResultModal()
      this.closeModal()
    },
    closeResultModal() {
      this.showRiskResultModal = false
    },
    validate() {
      if (this.hasRiskModal && this.showRisk && !this.riskEvaluationId) {
        this.$notification.warning({
          message: '提示',
          description: '请先评估信用风险等级',
        })
        return false
      }
      return { riskEvaluationId: this.riskEvaluationId }
    },
    //链路
    getLinkOptionList() {
      this.linkOptionList.push({
        id: '1',
        name: 'S4',
      })
      this.linkOptionList.push({
        id: '2',
        name: 'ECC',
      })
    },
    // handleSegmentChange(value) {
    //   // this.segmentOptionList.forEach(item => {
    //   //   if (item.id === value) {
    //   //     this.$refs.CardView.setFormFieldsValue('link', item.link)
    //   //   } else {
    //   //     console.log('item')
    //   //     console.log(item)
    //   //   }
    //   // })
    //   console.log('选Segment----', value)
    //   this.$emit('getSegmentFromChild', value)
    // },
    //获取Segment列表
    async getSegmentLevelLists(value) {
      try {
        const { data } = await getSegmentLevelList({ business: value })
        this.segmentOptionList = data
        this._getFreezeSegmentList()
      } catch (error) {
        console.error(error)
      }
    },
    _getFreezeSegmentList() {
      getFreezeSegmentList().then(({ data }) => {
        this.segmentList = data
      })
    },
    async changeBusiness(value) {
      try {
        const { data } = await getModelList({ pid: value, type: 3 })
        this.modelList = data
        this._getFreezeModelList()
      } catch (err) {
        console.log(err)
      }
    },
    _getFreezeModelList() {
      getFreezeModelList().then(({ data }) => {
        this.moList = data
      })
    },

    handleChangeModel(value) {
      this.$emit('getModalFromChild', value)
    },
    handleChangeLink(value) {
      console.log('选链路----', value)
      this.$emit('getLinkFromChild', value)
    },
    handleSegmentChange(value) {
      // this.segmentOptionList.forEach(item => {
      //   if (item.id === value) {
      //     this.$refs.CardView.setFormFieldsValue('link', item.link)
      //   } else {
      //     console.log('item')
      //     console.log(item)
      //   }
      // })
      console.log('选Segment----', value)
      this.$emit('getSegmentFromChild', value)
    },
    handleRiskTypeChange(value) {
      console.log('选审批类型----', value)
      this.creditInfoData.riskType = value
      this.$emit('getRiskTypeFromChild', value)
    },
  },
  components: {
    CardView,
    CreditRiskRating,
  },
}
</script>

<style lang="less" scoped>
.creditInfoData
  /deep/
  .ant-descriptions-row
  .ant-descriptions-item:nth-child(3):before {
  display: inline-block;
  margin-right: 4px;
  color: #f5222d;
  font-size: 14px;
  font-family: SimSun, sans-serif;
  line-height: 1;
  content: '*';
}
</style>
